import { PouchDbRepository } from "../../external";
import StorageHelper from "../../helpers/StorageHelper";
const storageHelper = new StorageHelper();

export class BancoCaixaResponsaveisLocalService {
  static database = "bancos-caixas-responsaveis";
  static dbLocalRepository;

  static startSincronizacao() {
    if (!this.dbLocalRepository) {
      this.dbLocalRepository = new PouchDbRepository(this.database);
      this.dbLocalRepository.startSync();
    }
  }

  static stopSincronizacao() {
    if (this.dbLocalRepository) {
      this.dbLocalRepository.stopSync(true);
      this.dbLocalRepository = null;
    }
  }

  static async getAll(filtros, opcoes) {
    if (!this.dbLocalRepository) {
      return [];
    }
    return await this.dbLocalRepository.getAll(filtros, opcoes);
  }

  static async deletarDatabase() {
    this.startSincronizacao();
    await this.dbLocalRepository.deleteDatabase();
    this.dbLocalRepository = null;
    storageHelper.removeLocal(`_pouch_${this.database}`);
  }
}
